export default __webpack_public_path__ + "static/media/san-rafael-4.3ac40463.jpg";